// window-events.ts
import { fromEvent, Observable } from 'rxjs';
import { WindowService } from 'core/services/window.service';

export function fromWindowEvent<K extends keyof WindowEventMap>(
  event: K,
  options?: boolean | AddEventListenerOptions
): Observable<WindowEventMap[K]> {
  if (WindowService.isBrowser) {
    return fromEvent<WindowEventMap[K]>(window, event, options as any);
  }
  return new Observable<WindowEventMap[K]>();
}